import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Renewal } from "@/api/williams/renewals";
import { useFormContext } from "react-hook-form";

export function RenewalForm({ locked }: { locked: boolean }) {
  const form = useFormContext<Renewal>();
  const errors = form.formState.errors;
  const attachment = form.watch("attachment");

  function handleSelectAttachment() {
    document.getElementById("attachment")?.click();
    form.clearErrors("attachment");
  }

  return (
    <form autoComplete="off">
      <div className="row">
        {/* First Column */}
        <div className="col-lg-6 pe-md-3 pe-xl-5">
          {/* Process */}
          <div>
            <label htmlFor="process" className="col-form-label pb-0">
              Process <span className="text-danger">*</span>
            </label>
            <select
              className={`form-select ${errors.process && "border-danger"}`}
              disabled={locked}
              {...form.register("process")}
            >
              <option />
              <option>SMAW</option>
              <option>GTAW</option>
              <option>GMAW</option>
              <option>FCAW</option>
              <option>SAW</option>
            </select>
            {errors.process && <span className="text-danger">{errors.process.message}</span>}
          </div>
          {/* Technique */}
          <div>
            <label htmlFor="technique" className="col-form-label pb-0">
              Technique <span className="text-danger">*</span>
            </label>
            <select
              className={`form-select ${errors.technique && "border-danger"}`}
              disabled={locked}
              {...form.register("technique")}
            >
              <option />
              <option>Manual</option>
              <option>Semi-automatic</option>
              <option>Machine</option>
            </select>
            {errors.technique && <span className="text-danger">{errors.technique.message}</span>}
          </div>
          {/* Test Type */}
          <div>
            <label htmlFor="testType" className="col-form-label pb-0">
              Test Type <span className="text-danger">*</span>
            </label>
            <select
              className={`form-select ${errors.testType && "border-danger"}`}
              disabled={locked}
              {...form.register("testType")}
            >
              <option />
              <option>Production Weld</option>
              <option>Test Coupon</option>
            </select>
            {errors.testType && <span className="text-danger">{errors.testType.message}</span>}
          </div>
          {/* Acceptance Criteria */}
          <div>
            <label htmlFor="acceptanceCriteria" className="col-form-label pb-0">
              Acceptance Criteria <span className="text-danger">*</span>
            </label>
            <select
              className={`form-select ${errors.acceptanceCriteria && "border-danger"}`}
              disabled={locked}
              {...form.register("acceptanceCriteria")}
            >
              <option />
              <option>ASME IX</option>
              <option>ASME B31.3</option>
              <option>API 1104 App. A</option>
              <option>API 1104 Sec. 6</option>
              <option>API 1104 Sec. 9</option>
              <option>API 1104 Sec. 12</option>
              <option>Other</option>
            </select>
            {errors.acceptanceCriteria && <span className="text-danger">{errors.acceptanceCriteria.message}</span>}
          </div>
        </div>

        {/* Second Column */}
        <div className="col-lg-6 ps-md-3 ps-xl-5">
          {/* NDE Method */}
          <div>
            <label htmlFor="ndeMethod" className="col-form-label pb-0">
              NDE Method <span className="text-danger">*</span>
            </label>
            <select
              className={`form-select ${errors.ndeMethod && "border-danger"}`}
              disabled={locked}
              {...form.register("ndeMethod")}
            >
              <option />
              <option>None</option>
              <option>PT</option>
              <option>MT</option>
              <option>RT</option>
              <option>UT</option>
              <option>Other</option>
            </select>
            {errors.ndeMethod && <span className="text-danger">{errors.ndeMethod.message}</span>}
          </div>
          {/* Result */}
          <div>
            <label htmlFor="results" className="col-form-label pb-0">
              Result <span className="text-danger">*</span>
            </label>
            <select
              className={`form-select ${errors.result && "border-danger"}`}
              disabled={locked}
              {...form.register("result")}
            >
              <option />
              <option>Accept</option>
              <option>Reject</option>
            </select>
            {errors.result && <span className="text-danger">{errors.result.message}</span>}
          </div>
          {/* Weld Date */}
          <div>
            <label htmlFor="weldDate" className="col-form-label pb-0">
              Weld Date <span className="text-danger">*</span>
            </label>
            <input
              type="date"
              className={`form-control ${errors.weldDate && "border-danger"}`}
              disabled={locked}
              {...form.register("weldDate")}
            />
            {errors.weldDate && <span className="text-danger">{errors.weldDate.message}</span>}
          </div>
          {/* NDE Date */}
          <div>
            <label htmlFor="ndeDate" className="col-form-label pb-0">
              NDE Date <span className="text-danger">*</span>
            </label>
            <input
              type="date"
              className={`form-control ${errors.ndeDate && "border-danger"}`}
              disabled={locked}
              {...form.register("ndeDate")}
            />
            {errors.ndeDate && <span className="text-danger">{errors.ndeDate.message}</span>}
          </div>
        </div>
      </div>

      {/* Notes */}
      <div className="row">
        <div>
          <label htmlFor="notes" className="col-form-label pb-0">
            Notes
          </label>
          <textarea
            className={`form-control ${errors.notes && "border-danger"}`}
            rows={3}
            disabled={locked}
            {...form.register("notes")}
          />
          {errors.notes && <span className="text-danger">{errors.notes.message}</span>}
        </div>

        <div>
          <input
            type="file"
            id="attachment"
            className="d-none"
            onChange={(e) => form.setValue("attachment", e.target.files?.[0])}
          />
          <input
            type="button"
            className="btn btn-default mt-3"
            value="Add Attachment"
            onClick={handleSelectAttachment}
            disabled={locked}
          />
          {attachment && (
            <div className="d-flex mt-2">
              <button
                type="button"
                className="btn btn-link text-black p-0 lh-sm"
                title="Remove Attachment"
                onClick={() => form.setValue("attachment", undefined)}
                disabled={locked}
              >
                <FontAwesomeIcon role="button" icon={faXmark} border={true} />
              </button>
              <span className="ms-2">{attachment.name}</span>
            </div>
          )}
          {errors.attachment && <div className="text-danger">{errors.attachment.message}</div>}
        </div>
      </div>
    </form>
  );
}
